import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/telemetry";

export function PageViewTracker() {
  const { pathname } = useLocation();
  const lastTracked = useRef<string | null>(null);

  useEffect(() => {
    if (lastTracked.current === pathname) {
      return;
    }

    lastTracked.current = pathname;
    trackPageView("viewer", pathname);
  }, [pathname]);

  return null;
}
